"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const yup_1 = require("@hookform/resolvers/yup");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const yup = __importStar(require("yup"));
const auth_api_1 = require("../../../utils/api/auth/auth.api");
const Utils_1 = require("../../../utils/Utils");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
function UseForgetPasswordForm() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const validationSchema = yup.object().shape({
        email: yup
            .string()
            .email()
            .required("L'email est un champs requis")
            .label("email"),
    });
    const [forgetPassword, { error, isSuccess, isLoading, originalArgs }] = (0, auth_api_1.useForgetPasswordMutation)();
    const { register, handleSubmit, formState: { errors }, clearErrors, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    (0, react_1.useEffect)(() => {
        if (errors) {
            (0, Utils_1.cleannerError)(errors, clearErrors);
        }
    }, [errors]);
    const onSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        data["email"] = (_a = data.email) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        const res = yield forgetPassword(data);
        if (res.data.success === true) {
            react_hot_toast_1.default.success("Un email vous a été envoyer. Veuillez consulter votre adresse email.", {
                duration: 5000,
                position: "top-center",
            });
            setTimeout(() => {
                navigate("/reinitialiser-mot-de-passe", {
                    replace: true,
                    state: { email: data === null || data === void 0 ? void 0 : data.email },
                });
            }, 3000);
        }
        else {
            react_hot_toast_1.default.error(res.data.message, {
                duration: 5000,
                position: "top-center",
            });
        }
    });
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        clearErrors,
        isLoading,
    };
}
exports.default = UseForgetPasswordForm;
